import { IWeeklySchedulerAdapter } from '@captiveaire/weeklyscheduler';
import { INamedFrameModel } from '@caslink/common-client';
import * as _ from 'lodash';
import { NamedFrameModelWeeklySchedulerItem } from '../shared/models/named-frame-model-weekly-scheduler-item.interface';

export class NamedFrameModelWeeklySchedulerAdapter implements IWeeklySchedulerAdapter<INamedFrameModel, string> {
    public items: NamedFrameModelWeeklySchedulerItem[] = [];
    constructor(public initialData: INamedFrameModel[]) {
    }
    public customModelToWeeklySchedulerRange(model: INamedFrameModel) {
        return {
            $class: model.name,
            day: model.day,
            start: model.start,
            end: model.end,
            value: model.name
        };
    }
    public getSnapshot(): INamedFrameModel[] {
        let result = Array.prototype.concat.apply([], this.items.map(item => {
            return item.schedules.map(schedule => {
                return {
                    day: schedule.day,
                    start: schedule.start,
                    end: schedule.end,
                    name: schedule.value
                };
            });
        }));
        return _.sortBy(result, 'day', 'start');
    }
}
